import axios from 'axios';

export function getIpeds() {
    return axios.get("/api/services/app/Tagging/GetIpeds");
}